import { useState } from "react";
import { useNavigate } from "react-router";
import { eftPath } from "../constants/routes";
import type { AwaitingEvidenceItem } from "../models/awaitingEvidence";
import AwaitingEvidenceWarning from "./AwaitingEvidenceWarning";
import CleModal, { CleModalRoot } from "./CleModal";

type AwaitingEvidenceWarningModalProps = {
  items: AwaitingEvidenceItem[] | undefined;
};

/**
 * Vises, når advokaten åbner indberetningen og har dokumentation, der afventer behandling.
 * Den sidder i selve flowet frem for på "Indberet"-knappen, fordi flowet kan nås fra
 * forsiden, fra listerne over indberetninger og afgørelser og fra et direkte link.
 *
 * Der skal vælges aktivt: modalen kan ikke lukkes med Escape eller ved at klikke udenfor.
 */
const AwaitingEvidenceWarningModal = ({
  items,
}: AwaitingEvidenceWarningModalProps) => {
  const navigate = useNavigate();
  const [hasContinued, setHasContinued] = useState(false);
  const isOpen = !hasContinued && (items?.length ?? 0) > 0;

  return (
    <CleModalRoot
      controller={{
        open: isOpen,
        setOpen: (open) => {
          if (!open) {
            setHasContinued(true);
          }
        },
      }}
    >
      <CleModal
        dialog
        size="sm"
        title="Du har dokumentation, der afventer behandling"
        description="Dokumentation, der endnu ikke er behandlet, indgår ikke i indberetningen, hvis den foretages nu."
      >
        <AwaitingEvidenceWarning
          continueButtonId="cle-awaiting-evidence-continue"
          continueLabel="Fortsæt til indberetningen"
          items={items ?? []}
          linkToDocuments
          onContinue={() => setHasContinued(true)}
          onWait={() => {
            void navigate(eftPath());
          }}
          waitButtonId="cle-awaiting-evidence-wait"
          waitLabel="Vent med at indberette"
        />
      </CleModal>
    </CleModalRoot>
  );
};

export default AwaitingEvidenceWarningModal;
